var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "table b-table table-hover table-bordered no-wrap" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.list, function(item) {
            return _c("tr", { key: item.id }, [
              _c("td", [_vm._v(_vm._s(_vm.formatDate(item.start)))]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(item.end ? _vm.formatDate(item.end) : ""))
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("currency")(item.value ? item.value : 0)) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("currency")(
                        item.valueToReceive ? item.valueToReceive : 0
                      )
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(item.comission ? item.comission : 0) + " %")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("currency")(item.traderValue ? item.traderValue : 0)
                  )
                )
              ])
            ])
          }),
          _vm._v(" "),
          _c("tr", [
            _c("td", { attrs: { colspan: "5" } }),
            _vm._v(" "),
            _c("td", [
              _c("strong", [
                _vm._v(
                  "Total: " +
                    _vm._s(_vm._f("currency")(_vm.getTotalTraderValue()))
                )
              ])
            ])
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("td", [_vm._v("Início")]),
        _vm._v(" "),
        _c("td", [_vm._v("Fim")]),
        _vm._v(" "),
        _c("td", [_vm._v("Valor Investido")]),
        _vm._v(" "),
        _c("td", [_vm._v("Valor")]),
        _vm._v(" "),
        _c("td", [_vm._v("Comissão")]),
        _vm._v(" "),
        _c("td", [_vm._v("Valor a receber")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }